import React, {PureComponent} from 'react';
import TranslationComponent from '../../components/translation'
import {database} from "../../logic/firebase";
import moment from 'moment';

export default class TranslationContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            translation: null
        }
    }

    componentDidMount() {
        this.getTranslation();
    }

    getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    getTranslation = () => {
        const translation = database().ref('/translation');
        translation.on('value', (snapshot) =>
            this.setState({translation: snapshot.val()})
        )
    };

    setTranslationInfo = (videoUrl, startTime) => {
        if (startTime) {
            database().ref('/translation/startTime').set(moment.utc(startTime).toLocaleString())
        }
        if (videoUrl) {
            const videoId = this.getParameterByName('v', videoUrl);
            database().ref('/translation/videoUrl').set(videoUrl);
            database().ref('/translation/videoId').set(videoId);
        }
    };

    onStart = () => {
        database().ref('/translation/startTime').set(moment().toLocaleString());
        database().ref('/translation/isStarted').set(true);
        database().ref('/translation/isEnded').set(false);
    };

    onStop = () => {
        database().ref('/translation/endTime').set(moment().toLocaleString());
        database().ref('/translation/isEnded').set(true);
        database().ref('/translation/isStarted').set(false);
    };

    onReset = async () => {
        await database().ref('/translation/isEnded').set(false);
        await database().ref('/translation/isStarted').set(false);
    };

    clearAll = async () => {
        await Promise.all([
            database().ref('/votes').remove(),
            database().ref('/translation/currentTrack').remove(),
            database().ref('/translation/isStarted').set(false),
            database().ref('/translation/isEnded').set(false),
            database().ref('/translation/playedTracks').remove(),
            database().ref('/translation/showTally').set(false),
            database().ref('/showTally').set(false),
            database().ref('/playedTracks').remove(),
            database().ref('/currentTrack').remove(),
            database().ref('/comments').remove(),
            database()
                .ref('/tracks')
                .remove(),
            database()
                .ref('/translation/tracks')
                .remove(),
            database()
                .ref('/playedTracks')
                .remove(),
            database()
                .ref('/translation/playedTracks')
                .remove(),
            database()
                .ref('/translation/currentTrack')
                .remove(),
            database()
                .ref('/currentTrack')
                .remove(),
        ])

    };

    saveEvent = async ({eventName, eventDescription, eventUrl, imageUrl, eventDate}) => {
        const {translation} = this.state;
        if (translation) {
            const votesSnap = await database().ref('/votes').once('value')
            const votes = votesSnap.val();
            const eventId = new Date().getTime()
            await database().ref('/events/' + eventId)
                .set({
                    id: eventId,
                    name: eventName,
                    description: eventDescription,
                    videoUrl: eventUrl || 'empty',
                    image: imageUrl || 'empty',
                    featuredTracks: translation.playedTracks,
                    registeredTracks: translation.tracks,
                    votes,
                    status: 'Pending',
                    date: eventDate
                })
        }
    }

    render() {
        const {translation} = this.state;
        return (
            <TranslationComponent
                onClearAll={this.clearAll}
                onReset={this.onReset}
                onStart={this.onStart}
                onStop={this.onStop}
                onSave={this.saveEvent}
                translation={translation}
                setTranslationInfo={this.setTranslationInfo}
            />
        )
    }
}